import React from "react";
import { FaTh, FaList } from "react-icons/fa";
import "../styles/ViewToggle.css";

const ViewToggle = ({ viewMode, onToggle }) => {
  return (
    <div className="view-toggle">
      <button
        className={`view-toggle-btn ${viewMode === 'cards' ? 'active' : ''}`}
        onClick={() => onToggle('cards')}
        title="Vue cartes"
      >
        <FaTh />
      </button>
      <button
        className={`view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
        onClick={() => onToggle('list')}
        title="Vue liste"
      >
        <FaList />
      </button>
    </div>
  );
};

export default ViewToggle;
